var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 10.1998 1.78171 11.3337 2.28259 12.3394C2.4157 12.6066 2.46001 12.9121 2.38284 13.2004L1.93613 14.87C1.74221 15.5948 2.40526 16.2578 3.13001 16.0639L4.79954 15.6172C5.08795 15.54 5.39341 15.5843 5.66065 15.7174C6.66628 16.2183 7.80023 16.5 9 16.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 9C11.25 9.41422 11.5858 9.75 12 9.75C12.4142 9.75 12.75 9.41422 12.75 9C12.75 8.58578 12.4142 8.25 12 8.25C11.5858 8.25 11.25 8.58578 11.25 9Z",
    fill: "#00CEBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9C8.25 9.41422 8.58578 9.75 9 9.75C9.41422 9.75 9.75 9.41422 9.75 9C9.75 8.58578 9.41422 8.25 9 8.25C8.58578 8.25 8.25 8.58578 8.25 9Z",
    fill: "#00CEBC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9C5.25 9.41422 5.58579 9.75 6 9.75C6.41421 9.75 6.75 9.41422 6.75 9C6.75 8.58578 6.41421 8.25 6 8.25C5.58579 8.25 5.25 8.58578 5.25 9Z",
    fill: "#00CEBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatRound);
export default __webpack_public_path__ + "static/media/chatRound.39fae037b3709116a1e5149c0dffc675.svg";
export { ForwardRef as ReactComponent };